import comInfo from 'views/Setup/CompanyInfo/i18n';
import users from 'views/Setup/Users/i18n';
import organChart from 'views/Setup/OrganisationChart/i18n';
import permissionProfile from 'views/Setup/PermissionProfile/i18n';
import emailTemplates from 'views/email/i18n';
import objectFilter from 'components/page/ObjectFilter/i18n';
import customField from 'components/ui/CustomField/i18n';
import filterCriteria from 'components/page/FilterCriteria/i18n';
import fields from 'views/Setup/Fields/i18n';
import selectionPool from 'components/ui/SelectionPool/i18n';
import layouts from 'views/Setup/PageLayout/i18n';
import taskDetails from 'components/page/TaskDetails/i18n';
import assigneeModal from 'components/ui/AssigneeModal/i18n';
import subjectsModal from 'components/ui/SubjectsModal/i18n';
import filterResultsTable from 'components/ui/FilterResultsTable/i18n';
import mySetting from 'views/MySetting/i18n';
import topPanel from 'components/page/TopPanel/i18n';
import mergeLeads from 'views/MergeLeads/i18n';
import convertLeads from 'views/ConvertLeads/i18n';
import primaryDetails from 'components/page/PrimaryDetails/i18n';
import dashboard from 'views/Dashboard/i18n';
import task from 'views/Task/i18n';
import objectList from 'views/ObjectList/i18n';
import convertDetails from 'components/page/ConvertDetails/i18n';
import findDuplicates from 'components/page/FindDuplicates/i18n';
import invoice from 'views/Invoice/i18n';
import FilterCriteria__REFACTORED from 'components/page/FilterCriteria__REFACTORED/i18n';
import Attachment from 'views/Attachment/i18n';
import ReportSetup from 'views/ReportSetup/i18n';
import ReportFilters from 'views/ReportFilters/i18n';
import ReportTableSetup from 'views/ReportTableSetup/i18n';
import ReportPreview from 'views/ReportPreview/i18n';
import ReportListSider from 'views/ReportListSider/i18n';
import ReportListPanel from 'views/ReportListPanel/i18n';

import SharedStatusIcon from 'components/ui/SharedStatusIcon/i18n';
import RealTimeReport from 'views/RealTimeReport/i18n';
import Modals from 'components/ui/Modals/i18n';
import Section_SharedTo from 'views/Section_SharedTo/i18n';
import RealTimeReport_Table from 'views/RealTimeReport_Table/i18n';
import DashboardSettings from 'views/DashboardSettings/i18n';
import EditableTitle from 'views/DashboardSettings_Slot/components/EditableTitle/i18n';
import SlotTable from 'views/DashboardSettings_Slot/components/Table/i18n';
import DashboardSettings_Details from 'views/DashboardSettings_Details/i18n';
import IpWhiteLists from 'views/Setup/IpWhiteLists/i18n';
import FieldFilterModal from 'components/page/FieldFilterModal/i18n';
import GeneralSettings from 'views/Setup/GeneralSettings/i18n';
import ObjectImport from 'views/Setup/ObjectImport/i18n';
import ObjectExport from 'views/Setup/ObjectExport/i18n';
import Auth from 'views/Auth/i18n';
import AttachAccount from 'views/AttachAccount/i18n';
import WorkFlow from 'views/Setup/WorkFlow/i18n';
import WorkflowList from 'views/Setup/WorkflowList/i18n';
import ApiToken from 'views/Setup/ApiToken/i18n'

export default {
  comInfo,
  users,
  organChart,
  emailTemplates,
  permissionProfile,
  objectFilter,
  customField,
  filterCriteria,
  fields,
  selectionPool,
  layouts,
  taskDetails,
  assigneeModal,
  subjectsModal,
  filterResultsTable,
  mySetting,
  topPanel,
  mergeLeads,
  convertLeads,
  primaryDetails,
  dashboard,
  task,
  objectList,
  convertDetails,
  findDuplicates,
  invoice,
  FilterCriteria__REFACTORED,
  Attachment,
  ReportSetup,
  ReportFilters,
  ReportTableSetup,
  ReportPreview,
  SharedStatusIcon,
  RealTimeReport,
  ReportListSider,
  ReportListPanel,
  Modals,
  Section_SharedTo,
  RealTimeReport_Table,
  DashboardSettings,
  EditableTitle,
  SlotTable,
  DashboardSettings_Details,
  IpWhiteLists,
  FieldFilterModal,
  GeneralSettings,
  ObjectImport,
  ObjectExport,
  Auth,
  AttachAccount,
  WorkFlow,
  WorkflowList,
  ApiToken
};



// WEBPACK FOOTER //
// ./src/i18n/page/index.js